import React from 'react';
import {inject, observer} from 'mobx-react';
import {injectIntl} from 'react-intl';
import {Panel} from 'react-bootstrap';
import {Doughnut} from 'react-chartjs-2';


const priorities_data = {
  labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'], // Sample, overwritten later
  datasets: [
    {
      backgroundColor: [
        '#FF6384',
        '#FFCE56',
        '#36A2EB',
      ],
      hoverBackgroundColor: [
        '#FF6384',
        '#FFCE56',
        '#36A2EB',
      ],
      data: [65, 59, 80, 81, 56, 55, 40]
    }
  ]
};


@injectIntl @inject('analyticsStore') @observer
export default class PrioritiesPlot extends React.Component{
    render(){
        const {intl, analyticsStore} = this.props;
        priorities_data.labels = analyticsStore.prioritiesKeys.map( el => intl.formatMessage({id: el+"_label"}));
        priorities_data.datasets[0].data = analyticsStore.prioritiesValues;
        priorities_data.datasets[0].label = intl.formatMessage({id:'priorities_label'});

        return(
            <Panel>
                <h3>{intl.formatMessage({id: 'priorities_title' })}</h3>
                <br/> 
                <div className='text-center' style={{height: '280px', overflow: 'auto'}}>
                    <Doughnut
                        data={priorities_data}
                        options={
                            {
                                maintainAspectRatio: false,
                            }
                        }
                    />
                </div>
            </Panel>
        );
    }
};